// ===== Packages =====

import {
    getFunctions,
    httpsCallable,
}                               from 'firebase/functions';

// ===== Interfaces =====

import {
    IAnnotationItem,
}                               from '../interfaces';

const getAnnotationById = async ({
    test,
    annotationId,
}: {
    test: boolean,
    annotationId: string,
}): Promise<IAnnotationItem | null> => {
    const functions = getFunctions();
    const handleGetAnnotationById = httpsCallable<
        Record<
            string,
            boolean | string
        >,
        IAnnotationItem | null
    >(
        functions,
        'getAnnotationById',
    );
    return handleGetAnnotationById({
        test,
        annotationId,
    }).then((result) => {
        const annotation = result.data as IAnnotationItem | null;
        return annotation;
    }).catch((err) => {
        throw err;
    });
};

export default getAnnotationById;
